import { forwardRef, PropsWithChildren } from "react";

import styles from "./MenuWrapper.module.css";
import { useMediaQuery } from "~/hooks/useMediaQuery";

const MenuWrapper = forwardRef<HTMLDivElement, PropsWithChildren>(
  ({ children }, ref) => {
    const isMobile = useMediaQuery("(max-width: 768px)");

    const minHeight = (() => {
      if (isMobile) {
        const stickyOffset = [
          '[data-sticky="header"]',
          '[data-sticky="offline-banner"]',
          '[data-sticky="menu-tabs"]',
        ].reduce((acc, selector) => {
          const element = document.querySelector(selector);
          return acc + (element?.getBoundingClientRect().height || 0);
        }, 0);

        return `calc(100vh - ${stickyOffset}px + 1px)`;
      }
      return "auto";
    })();

    return (
      <div ref={ref} className={styles.wrapper} style={{ minHeight }}>
        {children}
      </div>
    );
  },
);

MenuWrapper.displayName = "MenuWrapper";

export default MenuWrapper;
